import { v4 as uuidv4 } from "uuid";
import { makeAutoObservable } from "mobx";
import { runInAction } from "mobx";
class RangeStore {
  id = uuidv4();
  rootStore;
  fieldKey; s
  min = 0;
  max = 0;
  start = 0;
  end = 0;
  increaseSpeed = 5;
  constructor(rootStore, fieldKey) {
    this.rootStore = rootStore;
    this.fieldKey = fieldKey;
    makeAutoObservable(this);
    this.setRange = this.setRange.bind(this);
  }
  setRange({start, end, trigger = false}) {
    runInAction(() => {
      this.start = start;
      this.end = end;
      if (trigger === true) {
        this.rootStore.generateCompanyApi({triggerKey:trigger})
      }
    });
  }
  setConfig(min, max, step) {
    this.min = min;
    this.max = max;
    this.increaseSpeed = step;
    this.start = min;
    this.end = max;
  }
  clearMe() {
    this.start = this.min;
    this.end = this.max;
  }
  get range() {
    return [this.start, this.end];
  }
}
export default RangeStore;
